import { put, takeEvery } from '@zaibot/fsa-saga';
import { delay, fork, select } from '../../redux-saga';
import { questionsBatch, questionsEditor, questionsResource } from './resource';

import { selectors as metaSelectors } from '../../meta/selectors';

import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../../auth/actions/LOGGEDOUT';
import { RaceEffect, SelectEffect, call, race, take } from 'redux-saga/effects';
import { INote, IParticipantId, IQuestionDB, IUsergroup } from '../../types';
import { notesEditor, notesResource } from '../notes/resource';
import { hack } from '../../browser/launch';
import NOTES_INSPECT from '../notes/actions/NOTES_INSPECT';
import QUESTION_INSPECT from './action/QUESTION_INSPECT';
import QUESTION_CHANGE_STATUS_BATCH from './action/QUESTION_CHANGE_STATUS_BATCH';
import { isType } from '@zaibot/fsa';
import QUESTION_CHANGE_STATUS_BATCH_COMPLETE from './action/QUESTION_CHANGE_STATUS_BATCH_COMPLETE';
import QUESTION_CHANGE_STATUS_BATCH_FAILURE from './action/QUESTION_CHANGE_STATUS_BATCH_FAILURE';
import { statusses, statussesallowed } from './authmodule/authcheck';
import { useridResource } from '../../participantid/resource';
import { usergroupResource } from '../../usergroup/resource';
import QUESTION_SAVE from './action/QUESTION_SAVE';

const maxDelayTime = 10000;
const minDelayTime = 1000;

export function* rootSaga(): Iterable<any> {
    yield fork(questionsResource.saga);
    yield fork(questionsEditor.saga);
    yield fork(questionsBatch.saga);
    yield fork(signalquestionsList);
    yield fork(signalcreate);
    yield fork(signalupdate); 
    yield fork(signalupdatecontinue); 
    yield fork(signallistbeheer);   
    yield fork(monitorSelectedNote);
    yield fork(signalquestionsReset);
    yield fork(monitorNotesInspectQuestion);
    yield fork(signalChangeBatchStatus);
}

function* signalquestionsList() {
    yield takeEvery(AUTHENTICATED, function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        yield put(questionsResource.actions.LIST({ params: { selectionDocumentId } }));
    });
}

function* signalcreate() {
    yield takeEvery([
        notesResource.actions.CREATE_SUCCESS,
        ], function*(action) {          
        const note = action.payload.item;
        if (note) {         
            if (note.isquestion) {
                const question: IQuestionDB = yield select(questionsEditor.selectors.item);
                if (question) {
                    question.noteId=note.id;
                    try {
                        yield put(questionsEditor.actions.CREATE_CONTINUE({ item: questionsResource.create(question) as IQuestionDB }));
                    } catch (error) {
                        // tslint:disable-next-line
                        console.log('Question couldn\'t be backed up');
                        yield put(questionsEditor.actions.CREATE_CANCEL({}));   
                    }  
                }
            }
        }
    });   
}

function* signalupdate() {
    yield takeEvery([
        notesEditor.actions.UPDATE,
        ], function*(action) {
        // Bij een CREATE van de note wordt ook standaard een CREATE van
        // de question gedaan (in geval van een vraag) bij SELECTION
        if (action.payload.item) {  
            if (action.payload.item.isquestion) { 
                const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);
                var current = questions.qWhere((x) => x.noteId === action.payload.item.id).qFirst();
                if (current) {
                    try {
                        yield put(questionsEditor.actions.UPDATE({ item: current as IQuestionDB }));
                    } catch (error) {
                        // tslint:disable-next-line
                        console.log('Question couldn\'t be backed up');                    
                    } 
                } else {
                    // dient eigenlijk niet te gebeuren.
                    try {
                        yield put(questionsEditor.actions.CREATE({
                            item: fixNoteDevelopmentJsonServerQuestion({
                                status: 1,  
                                noteId: (action.payload.item as INote).id,
                                antwoordConcern:'',
                                practicionerId: undefined,
                            } as IQuestionDB)}));
                    } catch (error) {
                        // tslint:disable-next-line
                        console.log('Question couldn\'t be backed up');
                    } 
                }
            } 
        }
    });
}

function* signalupdatecontinue() {
    yield takeEvery([
        notesResource.actions.UPDATE_SUCCESS,
        ], function*(action) {   
        const note = action.payload.item;
        if (action.payload.item) {  
            if (action.payload.item.isquestion) { 
                var current: IQuestionDB = yield select(questionsEditor.selectors.item);
                if (current) {
                    try {
                        if (current.parentId) {
                            let allQuestions: IQuestionDB[]= yield select(questionsResource.selectors.items);
                            const parent = allQuestions.qFirst((o: IQuestionDB) =>  o.noteId === current.parentId) as IQuestionDB;
                            current.status = parent.status;
                            current.antwoordConcern = parent.antwoordConcern;
                        }
                        yield put(questionsEditor.actions.UPDATE_CONTINUE({ item: current as IQuestionDB }));
                    } catch (error) {
                        // tslint:disable-next-line
                        console.log('Question couldn\'t be backed up');                    
                    } finally {
                        let allQuestions: IQuestionDB[]= yield select(questionsResource.selectors.items);
                        const items = allQuestions.qWhere((o: IQuestionDB) =>  o.parentId=== note.id) as IQuestionDB[];
                        items.forEach((itm) => itm.antwoordConcern = current.antwoordConcern );
                        var batchstatus = statusses.qFirst((itm) =>itm.id===current.status);
                        yield put(QUESTION_CHANGE_STATUS_BATCH({items, batchstatus, batchchange: false}));
                    }
                } 
            } 
        }
    });
    yield takeEvery([
        QUESTION_SAVE,
        ], function*(action) {  
        if (action.payload.saveitem) {  
            var current: IQuestionDB = action.payload.saveitem;
            if (current) {
                try {
                    if (current.parentId) {
                        let allQuestions: IQuestionDB[]= yield select(questionsResource.selectors.items);
                        const parent = allQuestions.qFirst((o: IQuestionDB) =>  o.noteId === current.parentId) as IQuestionDB;
                        current.status = parent.status;
                        current.antwoordConcern = parent.antwoordConcern;
                    }
                    yield put(questionsEditor.actions.UPDATE_CONTINUE({ item: current as IQuestionDB }));
                } catch (error) {
                    // tslint:disable-next-line
                    console.log('Question couldn\'t be backed up');                    
                } finally {
                    let allQuestions: IQuestionDB[]= yield select(questionsResource.selectors.items);
                    const items = allQuestions.qWhere((o: IQuestionDB) =>  o.parentId=== current.noteId) as IQuestionDB[];
                    items.forEach((itm) => itm.antwoordConcern = current.antwoordConcern );
                    var batchstatus = statusses.qFirst((itm) =>itm.id===current.status);
                    yield put(QUESTION_CHANGE_STATUS_BATCH({items, batchstatus, batchchange: false}));
                }
            }       
        }
    });
}

function* signalChangeBatchStatus() {
    yield takeEvery(QUESTION_CHANGE_STATUS_BATCH, function*(action) {
        if (isType(action, QUESTION_CHANGE_STATUS_BATCH)) {
            let questions = action.payload.items;
            let statusnew = action.payload.batchstatus;
            let currentUser: IParticipantId[] = yield select(useridResource.selectors.items);
            var currentUserid =  currentUser.length > 0 ?  currentUser[0].id : '';
            const usergroups: IUsergroup[] = yield select(usergroupResource.selectors.items);

            if (questions) {
                var countQuestionsToUpdate = questions.length;
                if (countQuestionsToUpdate>0) {
                    try { 
                        for (var question of questions) { 
                            if (statussesallowed(statusses, question.status, currentUserid, usergroups).includes(statusnew)) {
                                question.status=statusnew.id;
                            }
                            yield put(questionsEditor.actions.UPDATE({item: question}));
                            const waiting: RaceEffect = yield race({
                                timeout: call(delay, maxDelayTime),
                                updateend: take([notesResource.actions.UPDATE_FAILURE, notesResource.actions.UPDATE_SUCCESS]),
                            });   
                            let waitresult: any = waiting;                
                            if (waitresult.updateend) {
                                 if (countQuestionsToUpdate>0) {
                                    yield put(questionsEditor.actions.UPDATE_CONTINUE({item: question}));
                                    countQuestionsToUpdate--;
                                    if (countQuestionsToUpdate===0) {
                                        yield call(delay, minDelayTime),
                                        yield put(QUESTION_CHANGE_STATUS_BATCH_COMPLETE({items: undefined, batchstatus: undefined, batchchange: false}));
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        // tslint:disable-next-line                  
                        console.log(error); 
                        yield put(QUESTION_CHANGE_STATUS_BATCH_FAILURE({items: undefined, batchstatus: undefined,  batchchange: true}));
                    }
                }   
            }
        }
    });
}

function fixNoteDevelopmentJsonServerQuestion(itemQuestion: IQuestionDB) {

    return itemQuestion;
}

function* signallistbeheer() {
    yield takeEvery<any, any>([
        questionsResource.actions.LIST_SUCCESS,
        questionsResource.actions.LIST_FAILURE,
        questionsResource.actions.CREATE_SUCCESS,
        questionsResource.actions.UPDATE_SUCCESS,
        questionsResource.actions.DELETE_SUCCESS,
    ], function*(action) {
        if (action.payload.item) {         
            yield put(questionsResource.actions.READ({ item: action.payload.item }));  
        }
    });
}

function* monitorSelectedNote() {
    yield takeEvery(notesEditor.actions.READ, function*(action) {
        const state = hack.store.getState();

        if (!questionsEditor.selectors.creating(state) && 
            !questionsEditor.selectors.creating(state)) {        

            if (action.payload.item.isquestion) {
                const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);
                var current = questions.qWhere((x) => x.noteId === action.payload.item.id).qFirst();
                if (current) {                
                    yield put(questionsEditor.actions.READ({ item: current }));  
                }
            }
        } 
    });
}

function* monitorNotesInspectQuestion() {
    const maxDelayTime = 3000;
    yield takeEvery([NOTES_INSPECT], function*(action) { 
        const note=action.payload.item;                    
        if (note && note.isquestion) {
            const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);
            var current = questions.qWhere((x) => x.noteId === action.payload.item.id).qFirst();
            if (current) {            
                yield put(QUESTION_INSPECT({ item: current }));  
            } else {
                var question=
                    {
                        status: 1,  
                        noteId: (action.payload.item as INote).id,
                        antwoordConcern:'',
                        parentId: undefined,
                        practicionerId: undefined,
                    } as IQuestionDB;
                yield put(questionsResource.actions.CREATE({ item: questionsResource.create(question) as IQuestionDB }));

                const waiting: RaceEffect = yield race({
                    timeout: call(delay, maxDelayTime),
                    createend: take([questionsResource.actions.CREATE_SUCCESS, notesResource.actions.CREATE_FAILURE]),
                });   
                let waitresult: any = waiting;                
                if (waitresult.createend) {
                    const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);   
                    current = questions.qWhere((x) => x.noteId === action.payload.item.id).qFirst();
                    if (current) {                                    
                        yield put(QUESTION_INSPECT({ item: current }));  
                    }             
                }

            }
        }        
    });
}

function* signalquestionsReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(questionsEditor.actions.RESET({ }));
        yield put(questionsResource.actions.RESET({ }));
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/sagas.tsx